<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="terms_box">
            <div class="tb_mainTitle">
              <h2>땡큐서울의원의원 개인정보 처리방침</h2>
            </div>
            <div class="tb_item">
              <div class="tb_content">
                <div class="tb_text">
                  <p>
                    땡큐서울의원의원(이하 ‘의원’이라 한다)는 개인정보 보호법 제30조에 따라
                    정보 주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여
                    다음과 같이 개인정보 처리지침을 수립·공개합니다.
                  </p>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제1조(개인정보의 처리목적)</h2>
                </div>
                <div class="tb_text">
                  <p>
                    의원은 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며,
                    이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
                  </p>
                  <div class="num">
                    <h2>홈페이지 회원 가입 및 관리 </h2>
                    <p>
                      회원 가입 의사 확인, 회원제 서비스 제공에 따른 본인 식별․인증, 회원자격 유지․관리, 제한적 본인 확인제 시행에 따른 본인확인,
                      서비스 부정이용 방지, 각종 고지 및 통지, 고충 처리 등을 목적으로 개인정보를 처리합니다.
                    </p>
                    <h2>재화 또는 서비스 제공</h2>
                    <p>
                      서비스 제공, 콘텐츠 제공, 맞춤 서비스 제공, 본인인증, 연령인증 등을 목적으로 개인 정보를 처리합니다.
                    </p>
                    <h2>진료 서비스 제공</h2>
                    <div class="dot">
                      <p>진료 예약 및 검사 예약 일정에 대한 고지 서비스</p>
                      <p>진료 및 업무, 교육, 연구, 통계, 환자 서비스에 필요한 분석 자료</p>
                      <p>진료 의뢰 또는 회송병원 의료인이 진료를 위한 목적으로 요청 시 진료 정보 제공</p>
                      <p>기타 진료와 관련된 서비스</p>
                      <p>진료 예약, 예약 조회, 검사결과 조회, 제증명 발급 신청, 수술 관리 등 홈페이지 회원제 서비스 제공</p>
                      <p>진료 예약, 예약 조회 및 기타 진료 서비스 이용에 따른 본인확인과 안내 절차에 사용</p>
                      <p>외부 수탁 검사를 위한 자료</p>
                      <p>신규 서비스 개발과 개인 맞춤 서비스 제공을 위한 자료</p>
                      <p>소비자기본법 제52조에 의거한 소비자 위해 정보 수집</p>
                      <p>홈페이지의 원활한 운영 및 통계분석자료로 활용 </p>
                      <p>기타 진료와 관련된 서비스</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제2조(개인정보의 처리 및 보유 기간)</h2>
                </div>
                <div class="tb_text">
                  <div class="num">
                    <h2>
                      의원은 법령에 따른 개인정보 보유·이용 기간 또는 정보 주체로부터
                      개인정보를 수집 시에 동의받은 개인정보 보유․ 이용 기간 내에서 개인정보를 처리·보유합니다.
                    </h2>
                    <div class="dot">
                      <p>
                        홈페이지 및 모바일앱 회원 정보의 경우 회원탈퇴 시까지 보유하고 해지 후에는 DB에서 삭제하고 보유하지 않습니다.
                        또한 개인정보가 제3자에게 제공된 경우에는 제3 자에게 파기하도록 지시합니다.
                        단, 다음 각호의 경우에는 각호에 명시한 기간 동안 개인정보를 보유합니다.
                      </p>
                      <div class="innerNum">
                        <p>
                          보유 기간을 회원에게 미리 고지하고 그 보유 기간이 경과하지 아니한 경우와 개별적으로 회원의 동의를 받을 경우에
                          약속한 보유 기간 동안 개인정보를 보유합니다.
                        </p>
                        <p>
                          수집목적 또는 제공받은 목적이 달성된 경우에도 상법 등 법령의 규정에 의해
                          보존할 필요성이 있는 경우에 개인정보를 보유합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제3조(개인정보의 제3자 제공)</h2>
                </div>
                <div class="tb_text">
                  <div class="num">
                    <h2>의원은 정보 주체의 개인정보를 제1조(개인정보의 처리목적)에서 명시한
                      범위 내에서만 처리하며, 정보 주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</h2>
                    <h2>의원은 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.</h2>
                    <div class="tb_table">
                      <table summary="개인정보의 제3자 제공">
                        <caption>개인정보의 제3자 제공</caption>
                        <thead>
                        <tr>
                          <th>제공받는 자</th>
                          <th>이용목적</th>
                          <th>제공 항목</th>
                          <th>제공 기간</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td>국민건강보험공단, 건강보험심사평가원</td>
                          <td>급여비용 심사, 지급, 대상여부 확인, 진료적정성 평가 등</td>
                          <td>성명, 주민등록번호, 진단명, 진료내역 등</td>
                          <td>국민건강보험법에 따름</td>
                        </tr>
                        </tbody>
                        <tfoot></tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제4조(개인정보 처리의 위탁)</h2>
                </div>
                <div class="tb_text">
                  <div class="num">
                    <h2>의원은 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</h2>
                    <div class="tb_table">
                      <table summary="개인정보 처리의 위탁">
                        <caption>개인정보 처리의 위탁</caption>
                        <thead>
                        <tr>
                          <th>수탁업체</th>
                          <th>위탁업무내용</th>
                          <th>위탁개인정보</th>
                          <th>개인정보 보유 및 이용기간</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td>(주)유비케어</td>
                          <td>전자진료기록관리</td>
                          <td>진료시 수집항목 전체</td>
                          <td>위탁계약 종료시 까지</td>
                        </tr>
                        <tr>
                          <td>의료법인삼광의료재단</td>
                          <td>진단검사서비스</td>
                          <td>검사대상 수집항목 전체</td>
                          <td>위탁계약 종료시 까지</td>
                        </tr>
                        <tr>
                          <td>한국임상의학연구소</td>
                          <td>진단검사서비스</td>
                          <td>검사대상 수집항목 전체</td>
                          <td>위탁계약 종료시 까지</td>
                        </tr>
                        <tr>
                          <td>김민경병리과의원</td>
                          <td>병리검사</td>
                          <td>병리검사관련 수집항목 전체</td>
                          <td>위탁계약 종료시 까지</td>
                        </tr>
                        </tbody>
                        <tfoot></tfoot>
                      </table>
                    </div>
                    <h2>의원은 위탁계약 체결 시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적.관리적 보호조치, 재위탁 제한, 수탁자에
                      대한 관리.감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고,
                      수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</h2>
                    <h2>위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제5조(정보 주체의 권리.의무 및 행사방법)</h2>
                </div>
                <div class="tb_text">
                  <div class="num">
                    <h2>정보 주체는 의원에 대해 언제든지 다음 각호의 개인정보 보호 관련 권리를
                      행사할 수 있습니다.</h2>
                    <p>1. 개인정보 열람 요구</p>
                    <p>2. 오류 등이 있을 경우 정정 요구</p>
                    <p>3. 삭제요구</p>
                    <p>4. 처리정지 요구</p>
                    <h2>제1항에 따른 권리 행사는 의원에 대해 서면, 전화, 전자우편, 모사전송
                      (FAX) 등을 통하여 하실 수 있으며 의원은 이에 대해 지체없이 조치하겠습니다.</h2>
                    <h2>정보 주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는
                      의원은 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</h2>
                    <h2>제1항에 따른 권리 행사는 정보 주체의 법정대리인이나 위임을 받은 자 등
                      대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</h2>
                    <h2>정보 주체는 개인정보 보호법 등 관계 법령을 위반하여 의원이 처리하고 있는 정보 주체 본인이나 타인의 개인정보 및 사생활을 침해하여서는 아니됩니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제6조(처리하는 개인정보 항목)</h2>
                </div>
                <div class="tb_text">
                  <p>의원은 다음의 개인정보 항목을 처리하고 있습니다.</p>
                  <div class="num">
                    <h2>홈페이지 및 모바일 앱 회원 가입 시</h2>
                    <div class="dot">
                      <p>일반 회원가입 시 수집 항목</p>
                    </div>
                    <p>회원 유형, 성명, 아이디, 비밀번호, 성별, 생년월일, 휴대전화 번호, 이메일,
                      병원차트번호(생성된 환자에 한함)</p>
                    <div class="dot">
                      <p>예비 회원가입 시 수집 항목</p>
                    </div>
                    <p>회원 유형, 성명, 아이디, 비밀번호, 성별, 생년월일, 이메일</p>
                    <h2>서비스 제공</h2>
                    <div class="innerNum">
                      <p>예약 시 수집 항목</p>
                      <div class="dot">
                        <p>진료예약: 성명, 아이디, 비밀번호, 성별, 생년월일, 휴대전화 번호, 이메일, 병원차트번호(생성된 환자에 한함)</p>
                        <p>전화예약상담: 휴대전화번호, 성명</p>
                      </div>
                      <p>진료 시 수집 항목</p>
                      <div class="dot">
                        <p>개인정보: 성명, 아이디, 비밀번호, 성별, 생년월일, 휴대전화 번호, 이메일, 병원등록번호</p>
                        <p>건강정보 : 병력 및 가족력 등 진료 서비스 제공을 위하여 의료진이 필요하다고 판단되는 개인 건강정보</p>
                      </div>
                    </div>
                    <h2>서비스 이용과정이나 서비스 제공 업무처리 과정에서 다음과 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.</h2>
                    <div class="dot">
                      <p>서비스 이용기록, 접속 로그, 쿠키, 접속 IP 정보 등</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제7조(개인정보의 파기)</h2>
                </div>
                <div class="tb_text">
                  <div class="num">
                    <h2>의원은 개인정보 보유 기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때는 지체없이 해당 개인정보를 파기합니다.</h2>
                    <h2>정보 주체로부터 동의받은 개인정보 보유 기간이 경과하거나 처리목적이
                      달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야
                      하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.</h2>
                    <h2>개인정보 파기의 절차 및 방법은 다음과 같습니다.</h2>
                    <div class="dot">
                      <p>파기절차 : 고객이 서비스 가입 등을 위해 기재한 개인정보는 서비스 해지 등 이용 목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 정보
                        보호 사유에 따라 삭제되거나 파기합니다.</p>
                      <p>파기방법 : 전자적 파일 형태의 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다. 종이 문서에 기록·저장된 개인정보는
                        분쇄하거나 소각하여 파기합니다.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제8조(개인정보의 안전성 확보조치)</h2>
                </div>
                <div class="tb_text">
                  <div class="num">
                    <p class="pl-10">의원은 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
                    <div class="dot">
                      <p>개인정보 취급 직원의 최소화 및 교육</p>
                    </div>
                    <p class="pl-10">개인 정보취급자의 지정을 최소화하고 정기적인 교육을 시행하고 있습니다.</p>
                    <div class="dot">
                      <p>정기적인 자체 감사 실시</p>
                    </div>
                    <p class="pl-10">개인정보 취급 관련 안정성 확보를 위해 연 1회 이상 정기적으로 자체 감사를
                      실시하고 있습니다.</p>
                    <div class="dot">
                      <p>내부관리계획의 수립 및 시행</p>
                    </div>
                    <p class="pl-10">개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.</p>
                    <div class="dot">
                      <p>개인정보의 암호화</p>
                    </div>
                    <p class="pl-10">이용자의 개인정보 중 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화하는 등의 별도 보안 기능을 사용하고 있습니다.</p>
                    <div class="dot">
                      <p>해킹 등에 대비한 기술적 대책</p>
                    </div>
                    <p class="pl-10">해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신ᆞ점검을 하며 외부로부터 접근이 통제된 구역에
                      시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.</p>
                    <div class="dot">
                      <p>개인정보에 대한 접근 제한</p>
                    </div>
                    <p class="pl-10">개인정보를 처리하는 데이터베이스시스템에 대한 접근 권한의 부여, 변경,
                      말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며
                      침입 차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.</p>
                    <div class="dot">
                      <p>접속기록의 보관 및 위변조 방지</p>
                    </div>
                    <p class="pl-10">개인정보처리시스템에 접속한 기록을 최소 1년 이상 보관, 관리하고 있으며,
                      접속 기록이 위변조 및 도난, 분실되지 않도록 보안 기능을 사용하고 있습니다.</p>
                    <div class="dot">
                      <p>비인가자에 대한 출입통제</p>
                    </div>
                    <p class="pl-10">개인정보를 보관하고 있는 개인 정보시스템의 물리적 보관장소를 별도로 두고
                      이에 대해 출입통제 절차를 수립, 운영하고 있습니다.</p>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제9조(개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항)</h2>
                </div>
                <div class="tb_text">
                  <div class="num">
                    <h2>의원은 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.</h2>
                    <h2>쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의
                      컴퓨터 브라우저에 보내는 소량의 정보이며 이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다.</h2>
                    <div class="dot">
                      <p>쿠키의 사용 목적: 이용자가 방문한 각 서비스와 웹사이트들에 대한
                        방문 및 이용형태, 인기 검색어, 보안 접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.</p>
                      <p>쿠키의 설치·운영 및 거부 : 웹브라우저 상단의 도구> 인터넷 옵션>
                        개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부할 수 있습니다.</p>
                      <p>쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제10조(개인정보 보호 책임자)</h2>
                </div>
                <div class="tb_text">
                  <div class="num">
                    <h2>의원은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와
                      관련한 정보 주체의 불만 처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호 책임자를 지정하고 있습니다.</h2>
                    <div class="dot">
                      <p>개인정보 보호책임자</p>
                      <p>성명 : 하정훈</p>
                      <p>직책 : 원장</p>
                      <p>전화번호 : 1522-8775</p>
                      <p>이메일: thanqseoul@gmail.com</p>
                      <p>(팩스번호): 02-563-5075</p>
                    </div>
                    <div class="dot">
                      <p>개인정보 보호 담당 부서</p>
                      <p>부서명 : 수간호사</p>
                      <p>담당자 : 이지현</p>
                      <p>전화번호 : 1522-8775</p>
                      <p>이메일: thanqseoul@gmail.com</p>
                      <p>(팩스번호): 02-563-5075</p>
                    </div>
                    <h2>정보 주체께서는 의원의 서비스(또는 사업)을 이용하시면서 발생한 모든
                      개인정보 보호 관련 문의, 불만 처리, 피해구제 등에 관한 사항을
                      개인정보 보호책임자 및 담당 부서로 문의하실 수 있습니다. 의원은 정보 주체의 문의에 대해
                      지체없이 답변 및 처리해드릴 것입니다.</h2>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제11조(개인정보 열람 청구)</h2>
                </div>
                <div class="tb_text">
                  <p>정보 주체는 개인정보 보호법 제35조에 따른 개인정보의 열람 청구를 아래의
                    부서에 할 수 있습니다. 의원은 정보 주체의 개인정보 열람 청구가 신속하게
                    처리되도록 노력하겠습니다.</p>
                  <div class="num">
                    <div class="dot">
                      <p>개인정보 보호 담당 부서</p>
                      <p>부서명 : 수간호사</p>
                      <p>담당자 : 이지현</p>
                      <p>전화번호 : 1522-8775</p>
                      <p>이메일: thanqseoul@gmail.com</p>
                      <p>(팩스번호): 02-563-5075</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제12조(권익침해 구제방법)</h2>
                </div>
                <div class="tb_text">
                  <p>정보 주체는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을
                    문의하실 수 있습니다.</p>
                  <p class="pt-10">&lt;아래의 기관은 의원과는 별개의 기관으로서, 의원의 자체적인 개인정보 불만
                    처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면
                    문의하여 주시기 바랍니다&gt;</p>
                  <div class="num">
                    <div class="dot">
                      <p>개인정보 침해신고센터 (한국인터넷진흥원 운영)</p>
                    </div>
                    <div class="bar">
                      <p>소관 업무 : 개인정보 침해 사실 신고, 상담 신청</p>
                      <p>홈페이지 : <a href="http://privacy.kisa.or.kr" _blank>privacy.kisa.or.kr</a></p>
                      <p>전화 : (국번 없이) 118</p>
                      <p>주소 : (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층 개인정보침해신고
                        센터</p>
                    </div>
                    <div class="dot">
                      <p>개인정보 분쟁 조정위원회</p>
                    </div>
                    <div class="bar">
                      <p>소관 업무 : 개인정보 분쟁 조정신청, 집단분쟁 조정 (민사적 해결)</p>
                      <p>홈페이지 : <a href="http://www.kopico.go.kr" _blank>www.kopico.go.kr</a></p>
                      <p>전화 : (국번 없이) 1833-6972</p>
                      <p>주소 : (03171)서울특별시 종로구 세종대로 209 정부서울청사 4층</p>
                    </div>
                    <div class="dot">
                      <p>대검찰청 사이버범죄수사단 : 02-3480-3573 (<a href="http://www.spo.go.kr" _blank>www.spo.go.kr</a>)</p>
                      <p>경찰청 사이버안전국 : 182 (<a href="http://cyberbureau.police.go.kr" _blank>http://cyberbureau.police.go.kr</a>)</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제13조(영상정보처리기기 설치.운영)</h2>
                </div>
                <div class="tb_text">
                  <p>의원은 아래와 같이 영상정보처리기기를 설치.운영하고 있습니다.</p>
                  <div class="num">
                    <h2>영상정보처리기기 설치근거.목적</h2>
                    <div class="dot">
                      <p>환자 및 시설 안전</p>
                      <p>화재 및 범죄 예방</p>
                      <p>차량도난 및 파손 방지</p>
                      <p>주·정차관리</p>
                    </div>
                    <h2>설치 대수, 설치 위치, 촬영범위</h2>
                    <div class="dot">
                      <p>설치대수 : 16대</p>
                      <p>설치 위치 및 촬영 범위 : 대기실, 복도, 진료실 등</p>
                    </div>
                    <h2>관리책임자, 담당 부서 및 영상정보에 대한 접근 권한자 : 원장 하정훈</h2>
                    <h2>영상정보 촬영시간, 보관 기간, 보관장소, 처리방법</h2>
                    <div class="dot">
                      <p>촬영시간 : 24시간 촬영</p>
                      <p>보관 기간 : 촬영 시부터 30일</p>
                      <p>보관장소 및 처리방법 : 영상정보처리기기 통제실에 보관. 처리</p>
                    </div>
                    <h2>영상정보 확인 방법 및 장소</h2>
                    <div class="dot">
                      <p>관리책임자(원장 하정훈)에 요구</p>
                    </div>
                    <h2>정보 주체의 영상정보 열람 등 요구에 대한 조치 : 개인 영상정보 열람.존재
                      확인 청구서로 신청하여야 하며, 정보 주체 자신이 촬영된 경우 또는 명백히
                      정보 주체의 생명.신체.재산 이익을 위해 필요한 경우에 한 해 열람을 허용함</h2>
                    <h2>영상정보 보호를 위한 안전성 확보조치</h2>
                    <p>의원은 영상정보에 대하여 암호화 조치 등을 통해 안전하게 관리하고 있습니다.
                      또한 병원은 개인 영상정보 보호를 위한 관리적 대책으로서 개인정보에 대한 접근 권한을
                      차등 부여하고 있고, 개인 영상정보의 위.변조 방지를 위하여
                      개인 영상정보의 생성 일시, 열람 시 열람 목적.열람자.열람 일시 등을 기록하여 관리하고 있습니다.
                      이 외에도 개인 영상정보의 안전한 물리적 보관을 위하여 잠금장치를 설치하고 있습니다.</p>
                  </div>
                </div>
              </div>
              <div class="tb_content">
                <div class="tb_title">
                  <h2>제14조(개인정보 처리방침 변경)</h2>
                </div>
                <div class="tb_text">
                  <div class="num">
                    <h2>이 개인정보 처리방침은 2020. 06. 01(출시일)부터 적용됩니다.</h2>
                    <h2>이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다.</h2>
                    <p>- 2020. 06. 01 ~ 적용</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btnWrap visible" @click="agree()" v-if="prevAddress">
        <button type="button" class="callTerms">동의</button>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '개인정보처리방침',
        prevUrl: '/'
      },
      prevAddress: false
    }
  },
  computed: {
    ...mapGetters([

    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_TEMPORARY_PRIVACY'
    ]),
    ...mapActions([

    ]),
    agree () {
      this.SET_TEMPORARY_PRIVACY(true)
      if (this.prevAddress) {
        history.go(-1)
      } else {
        this.$router.push('/authorizedTemporary')
      }
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  created () {
    if (sessionStorage.getItem('pathFromLoadUnAuth').indexOf('authorizedTemporary') === 1) {
      this.prevAddress = true
    }
    this.SET_POPUP(false)
  },
  beforeDestroy () {
    this.prevAddress = false
    this.SET_POPUP(false)
  }
}
</script>

<style lang="scss" scoped>
</style>
